import React from 'react';
import cn from 'classnames';
import { plansPath, privacyPath } from '@constants/paths';

/* Styles */
import styles from './discountdisclaimer.module.scss';

const FirstServiceDiscountDisclaimer = ({ planName = 'HelloTech Home' }: { planName: string }) => (
  <div className={styles.firstServiceDiscountDisclaimer}>
    <div className={cn('p1', styles.firstServiceDiscountDisclaimerInfo)}>
      Save even more with <strong>{planName}</strong>!<br />
      $69 for all in-home services.{' '}
      <a href={plansPath()} className="text-weight-medium">
        Learn More
      </a>
    </div>
    <div className={cn('caption n700', styles.firstServiceDiscountDisclaimerInfo)}>
      *Valid for new customers only. By signing up, you’ll be the first to receive exclusive offers and important announcements.
      <br />
      <a href={privacyPath()}>Privacy Policy</a>
    </div>
  </div>
);

export default React.memo(FirstServiceDiscountDisclaimer);
